/**
 * Guide step 3, Showings (BR-107, BR-112): how a first showing gets booked. Hosts the shared showings
 * setup (the same one the live listing's Showings tab uses); its times save as they are added and its
 * booking preferences save with "Save and continue".
 */

import { ShowingsSetup } from '../../listing-detail/showings/ShowingsSetup';
import type { GuideStepProps } from '../guide-steps';

export function ShowingsStep({ listing, handleRef, onDirtyChange, onSavingChange, onPrimaryLabelChange }: GuideStepProps) {
  if (!listing) return null;
  return (
    <div data-testid="guide-step-showings">
      <ShowingsSetup
        listing={listing}
        embedded
        headingLevel={1}
        handleRef={handleRef}
        onDirtyChange={onDirtyChange}
        onSavingChange={onSavingChange}
        onPrimaryLabelChange={onPrimaryLabelChange}
      />
    </div>
  );
}
